module.exports = __webpack_public_path__ + "static/media/SteeringFpIVizFlowOnly90.36adbf73.jpg";